import type { GlucoseMedianReadingInsight } from "@tandemdiabetes/sugarmate-api-react-client"
import { useCalculationsContext } from "../CalculationsContext"
import type { TileProps } from "./TileProps"
import { TileTimeSpan } from "./TileTimeSpan"
import { TileTitle } from "./TileTitle"
import { TileUnit } from "./TileUnit"
import { TileValue } from "./TileValue"
import {
  useDisplayGlucoseValue,
  useReadableGlucoseUnit,
} from "src/hooks"

export function GlucoseMedianReading(props: TileProps<GlucoseMedianReadingInsight>) {
  const {
    insightKey,
    range,
  } = props

  const displayGlucoseValue = useDisplayGlucoseValue()
  const glucoseUnit = useReadableGlucoseUnit()

  const { quartileCalculations } = useCalculationsContext()
  const { quartile2 } = quartileCalculations[range] || {}

  const value: string | undefined = quartile2 === undefined
    ? undefined
    : displayGlucoseValue(quartile2)

  return (
    <>
      <TileTitle insightKey={insightKey} />
      <TileTimeSpan
        id={`${insightKey}-time-range`}
        range={range}
      />
      <TileValue id={`${insightKey}-value`}>
        {value === undefined ? "--" : value}
      </TileValue>
      <TileUnit id={`${insightKey}-unit`}>
        {glucoseUnit}
      </TileUnit>
    </>
  )
}
